var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNigeriaMlottoMegaMillionsEvening(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 99 99",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fedc3c",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73 25zM.633 49.5C.633 22.501 22.501.633 49.5.633S98.367 22.501 98.367 49.5 76.499 98.367 49.5 98.367.633 76.499.633 49.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#0f52a0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.937 34.708 17.836-.043 3.945-12.648 5.831 12.648 12.777.129-8.875 7.417 4.588 11.105c-.214 0-11.662-6.088-11.662-6.088l-13.163 9.904 4.073-14.149-15.349-8.275z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.325 15.671.3-10.504 6.646 10.419 9.218-.386-5.317 6.86 4.673 8.404-8.232-3.73c-.214.129-7.375 8.061-7.375 8.061l.643-11.791-12.648-6.56 12.091-.772zm21.095 2.101 6.26 7.117 5.488-2.787-2.272 6.903 5.059 6.474-6.346-.729-3.044 7.675-1.758-9.475-9.004-1.972 7.417-3.516zm3.773 40.217 5.402-6.946-3.644-8.318 6.431 4.373 4.459-5.231-.472 8.103 4.931 4.459-5.531.986-.729 8.575-3.816-7.375zm-13.72 26.883 5.402-10.933-5.831-8.232 8.618 1.544 5.531-9.261.043 10.333 7.503 2.23-7.16 4.631c0 .214.557 10.462.557 10.462l-5.617-6.86-9.047 6.088z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.029 66.95 15.821-.943 5.617-12.691 2.916 12.134 11.705.257-10.333 7.846c.086.172 2.487 11.619 2.487 11.619l-9.433-6.045-13.42 10.504 6.689-14.706L25.03 66.95z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNigeriaMlottoMegaMillionsEvening);
export default __webpack_public_path__ + "static/media/nigeria_mlotto_mega_millions_evening.7c8a8eff909772c2d1c47f6dc716c71e.svg";
export { ForwardRef as ReactComponent };